import { render, staticRenderFns } from "./TableStockConfig.vue?vue&type=template&id=0cd196ca&scoped=true"
import script from "./TableStockConfig.vue?vue&type=script&lang=js"
export * from "./TableStockConfig.vue?vue&type=script&lang=js"
import style0 from "./TableStockConfig.vue?vue&type=style&index=0&id=0cd196ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd196ca",
  null
  
)

export default component.exports